import { Stack, Typography } from '@mui/material';
import { useUnit } from 'effector-react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
  $assessmentInfo,
  $currentQuestion,
  $questionIndex,
  $questions,
} from 'store/assessment/model';
import { $questionTimer } from 'store/assessment/questionTimer';
import { secondsToTimeStringFormat } from 'utils/secondsToMMSSFormat';
import { QuestionPageContext } from '../context';
import { getQuestionStatusLabel, getQuestionTimerColor } from '../utils';
import Timer from './Timer';

interface QuestionHeaderProps {
  title: string;
}

const QuestionHeader = ({ title }: QuestionHeaderProps) => {
  const { t } = useTranslation();

  const [currentQuestion, questionIndex, assessmentInfo, questionTimer, questions] = useUnit([
    $currentQuestion,
    $questionIndex,
    $assessmentInfo,
    $questionTimer,
    $questions,
  ]);

  const { remainingTime } = useContext(QuestionPageContext);

  return (
    <Stack direction='row' justifyContent='space-between' alignItems='center'>
      <Typography variant='h28' mb={1.5}>
        {title}
      </Typography>
      <Stack direction='row' spacing={1.5}>
        {currentQuestion && currentQuestion.time && (
          <Timer
            seconds={
              currentQuestion.time - (questions[questionIndex].candidateTime || 0) - questionTimer
            }
            color={(seconds) => getQuestionTimerColor(currentQuestion.time, seconds)}
            ariaLabel={(seconds) =>
              `Оставшееся время на вопрос: ${secondsToTimeStringFormat(seconds, t)}, статус: ${getQuestionStatusLabel(currentQuestion.time, seconds)}`
            }
            hideTimerOnExpire
            pulseOnEnding
            tooltipTitle='Обратный отсчёт на этот вопрос. По нулю вопрос можно продолжать, таймер скрывается.'
          />
        )}
        {assessmentInfo && remainingTime && (
          <Timer
            seconds={remainingTime - questionTimer}
            color='status.received'
            ariaLabel={(seconds) =>
              `Оставшееся время теста: ${secondsToTimeStringFormat(seconds, t)}`
            }
            hideTimerOnExpire
            sx={{ width: 120, textAlign: 'center' }}
            tooltipTitle='Обратный отсчёт всего теста. По нулю тест продолжается, таймер скрывается.'
          />
        )}
      </Stack>
    </Stack>
  );
};

export default QuestionHeader;
